// @/services/LocationClient.js
import { CandyClient } from "@cabysis/candy-client";
import { getToken } from "@/utilities/storage";
import { BACK_END_URL } from "@/utilities/config";

const locationOptions = {
  baseUrl: `${BACK_END_URL}/ubicacion`,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
  getToken: () => getToken(),
};

export class LocationClient extends CandyClient {
  constructor() {
    super(locationOptions);
  }

  // Obtener lista de países
  async getPaises() {
    return this.get(`/paises`);
  }

  // Obtener provincias por código de país
  async getProvincias(codigoPais) {
    return this.get(`/provincias/${codigoPais}`);
  }

  // Obtener ciudades por código de país y código de provincia
  async getCiudades(codigoPais, codigoProvincia) {
    return this.get(`/ciudades/${codigoPais}/${codigoProvincia}`);
  }
}
